import { render, staticRenderFns } from "./UnionPay.vue?vue&type=template&id=0342a3d2&scoped=true&"
import script from "./UnionPay.vue?vue&type=script&lang=js&"
export * from "./UnionPay.vue?vue&type=script&lang=js&"
import style0 from "./UnionPay.vue?vue&type=style&index=0&id=0342a3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342a3d2",
  null
  
)

export default component.exports